import logo from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-dark.svg';

import logoSm from 'assets/images/logo-collapsed.svg';
import styles from './index.module.scss';

export type LogoTypeProps = {
	collapsed?: boolean;
}

export const LogoType = ({ collapsed = false}: LogoTypeProps) => {
	return (
		<div className={`${styles.logo} ${collapsed && styles.collapsed}`}>
			{collapsed ? (
				<img src={logoSm} alt="crowd pear" />
			) : (
				<>
					<img src={logo} alt="crowd pear" className={styles.logoLight} />
					<img src={logoDark} alt="crowd pear" className={styles.logoDark} />
				</>
			)}
		</div>
	);
};
